export default {
  lock() {
    document.body.style.overflow = 'hidden';
  },
  unlock() {
    document.body.style.overflow = 'visible';
  },
};
